module.exports = __webpack_public_path__ + "static/media/2.d7b3f776.jpg";